var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndiaIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2092_401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V8.00156H0V0Z",
    fill: "#FF9933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00195H24V15.9988H0V8.00195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15.998H24V23.9996H0V15.998Z",
    fill: "#128807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15.2008C13.7681 15.2008 15.2008 13.7681 15.2008 12.0008C15.2008 10.2335 13.7681 8.80078 12.0008 8.80078C10.2335 8.80078 8.80078 10.2335 8.80078 12.0008C8.80078 13.7681 10.2335 15.2008 12.0008 15.2008Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 14.8002C13.5456 14.8002 14.7992 13.5466 14.7992 12.0002C14.7992 10.4538 13.5456 9.2002 11.9992 9.2002C10.4528 9.2002 9.19922 10.4538 9.19922 12.0002C9.19922 13.5466 10.4528 14.8002 11.9992 14.8002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 12.5604C12.3087 12.5604 12.5595 12.3097 12.5595 12.0004C12.5595 11.6911 12.3087 11.4404 11.9995 11.4404C11.6902 11.4404 11.4395 11.6911 11.4395 12.0004C11.4395 12.3097 11.6902 12.5604 11.9995 12.5604Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7556 12.5104C14.8344 12.5208 14.9068 12.4653 14.9171 12.3864C14.9275 12.3076 14.872 12.2352 14.7932 12.2249C14.7143 12.2145 14.642 12.27 14.6316 12.3488C14.6212 12.4277 14.6767 12.5 14.7556 12.5104Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 14.8013L12.0943 13.1213L11.9983 12.3213L11.9023 13.1213L11.9983 14.8013Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5306 13.2059C14.6041 13.2364 14.6883 13.2015 14.7188 13.128C14.7492 13.0545 14.7143 12.9703 14.6409 12.9399C14.5674 12.9094 14.4831 12.9443 14.4527 13.0178C14.4223 13.0913 14.4572 13.1755 14.5306 13.2059Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2751 14.7055L11.8026 13.1076L11.9169 12.31L11.6172 13.0579L11.2751 14.7055Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1323 13.821C14.1954 13.8694 14.2858 13.8575 14.3342 13.7944C14.3826 13.7314 14.3707 13.641 14.3076 13.5925C14.2445 13.5441 14.1541 13.556 14.1057 13.6191C14.0573 13.6822 14.0692 13.7726 14.1323 13.821Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.601 14.4262L11.5241 13.0193L11.841 12.2785L11.3578 12.9233L10.601 14.4262Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5896 14.313C13.6381 14.3761 13.7285 14.388 13.7915 14.3396C13.8546 14.2912 13.8665 14.2008 13.8181 14.1377C13.7697 14.0746 13.6793 14.0627 13.6162 14.1111C13.5531 14.1595 13.5412 14.2499 13.5896 14.313Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0193 13.9817L11.2752 12.8616L11.773 12.228L11.1394 12.7258L10.0193 13.9817Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9375 14.6427C12.9679 14.7161 13.0521 14.751 13.1256 14.7206C13.1991 14.6902 13.234 14.6059 13.2035 14.5325C13.1731 14.459 13.0889 14.4241 13.0154 14.4545C12.9419 14.485 12.907 14.5692 12.9375 14.6427Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57604 13.4003L11.079 12.6434L11.7238 12.1603L10.983 12.4771L9.57604 13.4003Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2215 14.7956C12.2319 14.8744 12.3043 14.9299 12.3831 14.9196C12.462 14.9092 12.5175 14.8369 12.5071 14.758C12.4967 14.6792 12.4244 14.6236 12.3455 14.634C12.2667 14.6444 12.2112 14.7167 12.2215 14.7956Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29537 12.7248L10.943 12.3827L11.6909 12.083L10.8933 12.1973L9.29537 12.7248Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4906 14.7585C11.4802 14.8373 11.5357 14.9097 11.6146 14.9201C11.6934 14.9304 11.7657 14.8749 11.7761 14.7961C11.7865 14.7172 11.731 14.6449 11.6522 14.6345C11.5733 14.6241 11.501 14.6796 11.4906 14.7585Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.19969 12.0013L10.8797 12.0973L11.6797 12.0013L10.8797 11.9053L9.19969 12.0013Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7941 14.5326C10.7636 14.6061 10.7985 14.6903 10.872 14.7207C10.9455 14.7512 11.0297 14.7163 11.0601 14.6428C11.0906 14.5693 11.0557 14.4851 10.9822 14.4547C10.9087 14.4242 10.8245 14.4591 10.7941 14.5326Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2945 11.277L10.8924 11.8046L11.69 11.9189L10.9421 11.6191L9.2945 11.277Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1819 14.1362C10.1335 14.1993 10.1454 14.2897 10.2085 14.3381C10.2716 14.3865 10.362 14.3746 10.4104 14.3115C10.4588 14.2484 10.4469 14.158 10.3838 14.1096C10.3207 14.0612 10.2303 14.0731 10.1819 14.1362Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57574 10.6029L10.9827 11.526L11.7235 11.8429L11.0787 11.3598L9.57574 10.6029Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68895 13.5936C9.62586 13.642 9.61395 13.7324 9.66237 13.7955C9.71078 13.8585 9.80118 13.8705 9.86427 13.822C9.92737 13.7736 9.93927 13.6832 9.89085 13.6201C9.84244 13.557 9.75204 13.5451 9.68895 13.5936Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0183 10.0232L11.1384 11.2791L11.772 11.7769L11.2742 11.1433L10.0183 10.0232Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36026 12.9414C9.28679 12.9718 9.2519 13.056 9.28233 13.1295C9.31277 13.203 9.397 13.2379 9.47048 13.2075C9.54395 13.177 9.57884 13.0928 9.54841 13.0193C9.51797 12.9458 9.43374 12.9109 9.36026 12.9414Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6026 9.57897L11.3595 11.0819L11.8426 11.7267L11.5258 10.9859L10.6026 9.57897Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20636 12.2254C9.12751 12.2358 9.07201 12.3082 9.08239 12.387C9.09277 12.4659 9.1651 12.5214 9.24395 12.511C9.3228 12.5006 9.3783 12.4283 9.36792 12.3494C9.35754 12.2706 9.28521 12.2151 9.20636 12.2254Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2771 9.29927L11.6192 10.9469L11.919 11.6948L11.8047 10.8972L11.2771 9.29927Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24443 11.4925C9.16558 11.4822 9.09325 11.5377 9.08287 11.6165C9.07249 11.6954 9.12799 11.7677 9.20684 11.7781C9.28569 11.7885 9.35802 11.733 9.36841 11.6541C9.37879 11.5753 9.32328 11.5029 9.24443 11.4925Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 9.20164L11.9057 10.8816L12.0017 11.6816L12.0977 10.8816L12.0017 9.20164Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46936 10.797C9.39589 10.7665 9.31165 10.8014 9.28122 10.8749C9.25078 10.9484 9.28567 11.0326 9.35915 11.0631C9.43262 11.0935 9.51686 11.0586 9.54729 10.9851C9.57773 10.9117 9.54284 10.8274 9.46936 10.797Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7249 9.29743L12.1974 10.8953L12.0831 11.6929L12.3828 10.945L12.7249 9.29743Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.86772 10.1819C9.80463 10.1335 9.71423 10.1454 9.66582 10.2085C9.6174 10.2716 9.6293 10.362 9.6924 10.4104C9.75549 10.4588 9.84589 10.4469 9.8943 10.3838C9.94272 10.3207 9.93082 10.2303 9.86772 10.1819Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.399 9.57672L12.4759 10.9836L12.159 11.7245L12.6422 11.0796L13.399 9.57672Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4104 9.68993C10.3619 9.62683 10.2715 9.61493 10.2085 9.66335C10.1454 9.71176 10.1335 9.80215 10.1819 9.86525C10.2303 9.92834 10.3207 9.94024 10.3838 9.89183C10.4469 9.84342 10.4588 9.75302 10.4104 9.68993Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9807 10.0213L12.7248 11.1413L12.227 11.7749L12.8606 11.2771L13.9807 10.0213Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0616 9.35929C11.0311 9.28581 10.9469 9.25092 10.8734 9.28136C10.7999 9.31179 10.765 9.39603 10.7955 9.4695C10.8259 9.54298 10.9101 9.57787 10.9836 9.54743C11.0571 9.517 11.092 9.43276 11.0616 9.35929Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.423 10.6017L12.9201 11.3585L12.2752 11.8417L13.0161 11.5248L14.423 10.6017Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7775 9.20636C11.7671 9.12751 11.6948 9.07201 11.6159 9.08239C11.5371 9.09277 11.4816 9.1651 11.4919 9.24395C11.5023 9.3228 11.5747 9.3783 11.6535 9.36792C11.7324 9.35754 11.7879 9.28521 11.7775 9.20636Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7037 11.2771L13.0561 11.6192L12.3082 11.919L13.1057 11.8047L14.7037 11.2771Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5084 9.24346C12.5188 9.16461 12.4633 9.09227 12.3845 9.08189C12.3056 9.07151 12.2333 9.12702 12.2229 9.20586C12.2125 9.28471 12.268 9.35705 12.3469 9.36743C12.4257 9.37781 12.4981 9.3223 12.5084 9.24346Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7993 12.0007L13.1193 11.9047L12.3193 12.0007L13.1193 12.0967L14.7993 12.0007Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.205 9.46936C13.2354 9.39589 13.2005 9.31165 13.127 9.28122C13.0536 9.25078 12.9693 9.28567 12.9389 9.35915C12.9085 9.43262 12.9434 9.51686 13.0168 9.54729C13.0903 9.57773 13.1745 9.54284 13.205 9.46936Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7045 12.7249L13.1066 12.1974L12.309 12.0831L13.0569 12.3828L14.7045 12.7249Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8201 9.86674C13.8685 9.80365 13.8566 9.71325 13.7935 9.66484C13.7304 9.61643 13.64 9.62833 13.5916 9.69142C13.5432 9.75452 13.5551 9.84491 13.6181 9.89333C13.6812 9.94174 13.7716 9.92984 13.8201 9.86674Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4262 13.4L13.0193 12.4769L12.2785 12.16L12.9233 12.6432L14.4262 13.4Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.313 10.4094C14.3761 10.361 14.388 10.2706 14.3396 10.2075C14.2912 10.1444 14.2008 10.1325 14.1377 10.1809C14.0746 10.2293 14.0627 10.3197 14.1111 10.3828C14.1595 10.4459 14.2499 10.4578 14.313 10.4094Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9836 13.9797L12.8636 12.7239L12.23 12.2261L12.7278 12.8596L13.9836 13.9797Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6417 11.0616C14.7152 11.0311 14.7501 10.9469 14.7196 10.8734C14.6892 10.7999 14.605 10.765 14.5315 10.7955C14.458 10.8259 14.4231 10.9101 14.4535 10.9836C14.484 11.0571 14.5682 11.092 14.6417 11.0616Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3993 14.424L12.6424 12.921L12.1593 12.2762L12.4762 13.017L13.3993 14.424Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7956 11.7775C14.8744 11.7671 14.9299 11.6948 14.9196 11.6159C14.9092 11.5371 14.8369 11.4816 14.758 11.4919C14.6792 11.5023 14.6236 11.5747 14.634 11.6535C14.6444 11.7324 14.7167 11.7879 14.7956 11.7775Z",
    fill: "#000088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7248 14.7037L12.3827 13.0561L12.083 12.3082L12.1973 13.1057L12.7248 14.7037Z",
    fill: "#000088"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2092_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiaIn);
export default __webpack_public_path__ + "static/media/India (IN).647ba7c0a57ee7ac0f949b98d100ccad.svg";
export { ForwardRef as ReactComponent };